// Shared non-component exports; keep component modules valid Fast Refresh boundaries.

export type DeltaPanelRow = {
  measure_id: string;
  measure_label: string;
  label_name: string;
  detection_rate: number;
  calls: number;
};

export type MergedRow = {
  key: string;
  measureLabel: string;
  labelName: string;
  current: { rate: number; calls: number } | null;
  prior: { rate: number; calls: number } | null;
  deltaPct: number | null;
  absDelta: number;
};

export function mergeRows(
  current: DeltaPanelRow[],
  prior: DeltaPanelRow[],
): MergedRow[] {
  const map = new Map<string, MergedRow>();
  const ensure = (
    key: string,
    measureLabel: string,
    labelName: string,
  ): MergedRow => {
    let row = map.get(key);
    if (!row) {
      row = {
        key,
        measureLabel,
        labelName,
        current: null,
        prior: null,
        deltaPct: null,
        absDelta: 0,
      };
      map.set(key, row);
    }
    return row;
  };
  for (const r of current) {
    const key = `${r.measure_id}::${r.label_name}`;
    const row = ensure(key, r.measure_label, r.label_name);
    row.current = { rate: r.detection_rate, calls: r.calls };
  }
  for (const r of prior) {
    const key = `${r.measure_id}::${r.label_name}`;
    const row = ensure(key, r.measure_label, r.label_name);
    row.prior = { rate: r.detection_rate, calls: r.calls };
  }
  for (const row of map.values()) {
    if (row.current && row.prior) {
      const delta = row.current.rate - row.prior.rate;
      row.deltaPct = delta * 100;
      row.absDelta = Math.abs(delta);
    } else {
      // New or dropped (measure, label) pair — sort to the top so
      // managers see "appeared" / "disappeared" rows as movers.
      row.deltaPct = null;
      row.absDelta = Number.POSITIVE_INFINITY;
    }
  }
  return Array.from(map.values()).sort((a, b) => {
    if (a.absDelta !== b.absDelta) return b.absDelta - a.absDelta;
    return (
      a.measureLabel.localeCompare(b.measureLabel) ||
      a.labelName.localeCompare(b.labelName)
    );
  });
}
